import { OmnibarEntry, OmnibarContext, OmnibarCitizenArea } from '../omnibar-interfaces';

export default function entryContextFilter(option: OmnibarEntry, currentContext: OmnibarContext, currentCitizenArea?: OmnibarCitizenArea) {
  if (option.context === 'none') return true;
  if (option.context === 'citizen' && currentContext === 'citizen') {
    return currentCitizenArea === undefined || (option.citizenArea ?? 'authority') === currentCitizenArea;
  }
  if (option.context === 'company' && currentContext === 'company') {
    return true;
  }
  return false;
}
